<template>
<table class="odr-table" :style="width && `width: ${width} !important;`">
    <tbody class="odr-table__tbody">
        <slot></slot>
    </tbody>
</table>
</template>
<script>
import '../styles/table.scss'

export default {
    props: {
        width: {
            type: String,
            _descr: 'Table width',
        },
    },
}
</script>
